import classNames from 'classnames';
import React from 'react';

import css from './JobsPageVacancy1.module.css';

const VacancyBlock = () => {

  return (
    <div>
      <h1 className={css.jobTitle}>Florida Lead Teacher / State Manager</h1>
      <div className={classNames(css.intro, css.yellow)}>
        <h3>Are you an elementary teacher, middle school teacher, or high school teacher who is licensed to teach in Florida?</h3>
        <p>AllCourse is a new site linking teachers offering for-credit ONLINE courses with schools, students, and parents. The way we see it, most teachers’ side jobs don’t pay all that well. Our solution? Have teachers teach online courses for schools (or home-schoolers) struggling to hire due to the nationwide teacher shortage or who simply want to increase their course offerings. Courses can be an entire semester, or just “helping out” on a day-by-day basis. Unlike with other course providers, AllCourse teachers make 85% or more of the course revenue. With AllCourse, schools can instantly solve their staffing problems; students can get access to subject matter they’d never have otherwise; and teachers can earn a lot of extra income working from home.</p>
        <p>Florida is one of our earliest and most important launch states. We are hiring immediately for a Florida-based Lead Teacher & State Manager, to teach live online virtual courses for Florida schools and students. You’ll also help with marketing, networking, and outreach to spread the word about AllCourse around Florida, and you’ll mentor teachers and schools as they use the service. As AllCourse grows, there will be many opportunities to keep learning new skills, increase your salary, and/or join us in a full-time role.</p>
      </div>
      <div className={css.jobDescriptionHolder}>
        <h2 className={css.desriptionTitle}>Job Description:</h2>
        <ul className={css.descriptionList}>
          <li>Teach live online to students in elementary, middle, and high school.</li>
          <li>Become an important early team member and manager of our Florida presence.</li>
          <li>Work remote from home, part time or full time, and set your own schedule.</li>
          <li>Meet with teachers and school administrators to spread the word about AllCourse.</li>
          <li>Speak about AllCourse at conferences, on virtual expert panels, and to the media.</li>
          <li>Work alongside the team that founded autograding pioneer Bakpax (acquired by Teachers Pay Teachers) and adaptive learning giant Knewton (acquired by Wiley).</li>
        </ul>
      </div>
      <div className={css.jobDescriptionHolder}>
        <h2 className={css.desriptionTitle}>Requirements:</h2>
        <ul className={css.descriptionList}>
          <li>Bachelor’s degree from an accredited college or university </li>
          <li>Based in Florida and authorized to work in the United States </li>
          <li>At least 3 years recent classroom teaching experience of grades 1-12 in traditional (public or private) schools in Florida</li>
          <li>Online teaching experience; highly engaging online presence</li>
          <li>High familiarity with educational content and technology</li>
          <li>High-energy, entrepreneurial self-starter</li>
          <li>Marketing, sales, or business development experience</li>
          <li>Licensed to teach in Florida (nice to have)</li>
        </ul>
      </div>
      <div className={css.jobDescriptionHolder}>
        <h2 className={css.desriptionTitle}>AllCourse is solving some fundamental problems in k-12 education today:</h2>
        <ul className={css.descriptionList}>
          <li>Teachers are underpaid and need better income opportunities</li>
          <li>Widespread teacher shortages are making it difficult to staff classrooms, creating chaos for administrators and students and causing states to dramatically reduce their teacher qualification requirements</li>
          <li>Students (and parents) want more flexibility and choice in subject matter and pedagogy</li>
        </ul>
      </div>
      <div className={css.borderBlock}>
        There are other companies that provide courses to schools — but they create the curriculum, hire the teachers, and keep all the profit. With AllCourse, teachers keep 85% or more of the revenue. <b>Teachers need a better way to make additional income. 
        Come join AllCourse and be part of the solution!</b>
      </div>
    </div>
  )
}

export default VacancyBlock;